module.exports = __webpack_public_path__ + "static/media/Dark.87444ef6.svg";